export default {
    init() {
        const categoriesWithChilderen = document.querySelectorAll('li.cat-parent');
        if (categoriesWithChilderen && categoriesWithChilderen.length) {
            categoriesWithChilderen.forEach((cat) => {
                if (cat.classList.contains('current-cat-parent') || cat.classList.contains('current-cat')) {
                    cat.querySelector('ul.children').classList.toggle('open');
                    cat.classList.toggle('open');
                }
                cat.firstChild.addEventListener('click', e => this.toggleClass(e, cat));
            });
        }
    },

    toggleClass(e, parent) {
        e.preventDefault();
        parent.querySelector('ul.children').classList.toggle('open');
        parent.classList.toggle('open');
    },
};
